// src/stone/icons/LogoWhatsapp2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var LogoWhatsapp2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "m.09 40 2.812-10.271a19.8 19.8 0 0 1-2.646-9.91C.26 8.892 9.155 0 20.083 0A19.7 19.7 0 0 1 34.11 5.813a19.7 19.7 0 0 1 5.802 14.023c-.005 10.928-8.9 19.82-19.827 19.82h-.009a19.8 19.8 0 0 1-9.475-2.412zm10.997-6.345.602.357a16.46 16.46 0 0 0 8.388 2.297h.006c9.084 0 16.476-7.39 16.48-16.475A16.37 16.37 0 0 0 31.741 8.18 16.37 16.37 0 0 0 20.09 3.348c-9.09 0-16.483 7.39-16.487 16.473a16.43 16.43 0 0 0 2.52 8.767l.392.624L4.85 35.29z" }),
      /* @__PURE__ */ jsx("path", { d: "M15.128 11.534c-.402-.966-.81-.835-1.115-.85-.288-.014-.619-.018-.95-.018s-.866.124-1.32.62-1.734 1.694-1.734 4.132 1.775 4.793 2.023 5.123c.247.33 3.493 5.333 8.463 7.478 1.182.51 2.105.815 2.824 1.044 1.187.377 2.267.323 3.12.196.952-.142 2.932-1.198 3.344-2.355.413-1.157.413-2.149.29-2.355-.124-.207-.455-.33-.95-.579-.496-.247-2.931-1.446-3.385-1.611s-.785-.248-1.115.248-1.28 1.611-1.569 1.942-.578.372-1.073.124-2.092-.771-3.984-2.458c-1.473-1.314-2.467-2.936-2.756-3.431s-.03-.764.217-1.011c.223-.222.496-.578.743-.868.248-.289.33-.495.496-.826s.082-.62-.042-.868c-.123-.248-1.114-2.685-1.527-3.677" })
    ]
  }
);
var LogoWhatsapp2X_default = LogoWhatsapp2X;

export {
  LogoWhatsapp2X,
  LogoWhatsapp2X_default
};
